<script>
export default {
  isCurrentWindowInIFrame: function () {
    return window.top !== window.self;
  },

  isCurrentWindowInPopup: function() {
    return window.opener;
  },

  reloadParentWindow: function () {		
    window.parent.location.reload();
  }
}
</script>
